import { isNullable } from '@ipfabric/utils';

const fixValue = (value) => {
  if (isNullable(value) || value === '') {
    return '*';
  }
  return value;
};

const getDaysOfWeek = (value) => {
  const fixedValue = fixValue(value);
  return fixedValue
    .split(',')
    .map((v) => {
      switch (v) {
        case '1':
          return 'MON';
        case '2':
          return 'TUE';
        case '3':
          return 'WED';
        case '4':
          return 'THU';
        case '5':
          return 'FRI';
        case '6':
          return 'SAT';
        case '7':
          return 'SUN';
        default:
          return v;
      }
    })
    .join(',');
};

const getValue = ({
  period,
  minuteField,
  minutes,
  hours,
  days,
  daysOfWeek,
  months,
}) => {
  switch (period) {
    case 'minute': {
      return `*/${minuteField} * * * *`;
    }
    case 'hour': {
      return `${fixValue(minutes)} * * * *`;
    }
    case 'day': {
      return `${fixValue(minutes)} ${fixValue(hours)} * * *`;
    }
    case 'week': {
      return `${fixValue(minutes)} ${fixValue(hours)} * * ${getDaysOfWeek(daysOfWeek)}`;
    }
    case 'month': {
      return `${fixValue(minutes)} ${fixValue(hours)} ${fixValue(days)} * *`;
    }
    case 'year': {
      return `${fixValue(minutes)} ${fixValue(hours)} ${fixValue(days)} ${fixValue(months)} *`;
    }
    default:
      return '';
  }
};

export default getValue;
